import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { combineLatest, Observable, of } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

import { AuthSelector } from "../../../auth/auth.selector";
import { DisallowedActionCodes } from "../../../customer-management/customer-management.model";
import { CustomerManagementSelector } from "../../../customer-management/customer-management.selector";
import { CoreState } from "../../../state";

/**
 * @deprecated [fabric-deprecated] - Use SessionLimitRequiredService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class SessionLimitRequiredService {
	constructor(private store: Store<CoreState>) {}

	shouldOpenSessionLimit$(): Observable<boolean> {
		return this.store.pipe(
			AuthSelector.isAuthenticated$,
			switchMap((isAuth) =>
				!isAuth
					? of(false)
					: combineLatest([
							this.store.select(CustomerManagementSelector.isBusy),
							this.store.select(CustomerManagementSelector.getCustomer),
						]).pipe(
							filter(([isBusy, customer]) => !isBusy && !!customer),
							switchMap(() => this.isSessionLimitUnset$())
						)
			)
		);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.IsSessionLimitUnset instead
	 */
	isSessionLimitUnset$(): Observable<boolean> {
		return this.store
			.select(CustomerManagementSelector.getAllowedAction)
			.pipe(
				map(
					(actions) =>
						!actions?.betCasino?.isAllowed &&
						!!actions?.betCasino?.disallowedReasons.includes(
							DisallowedActionCodes.M_CURRENTCUSTOMER_SESSIONLIMITUNSET
						)
				)
			);
	}
}
